







import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class CountdownTimer extends Vue {
  @Prop({ type: Number, default: null }) remainingMinutes!: number | null;

  timer: any = null;
  currentRemaining: number | null = null;

  mounted() {
    this.currentRemaining = this.remainingMinutes;
    if (this.currentRemaining !== null && this.currentRemaining > 0) {
      this.timer = setInterval(() => {
        if (this.currentRemaining !== null && this.currentRemaining > 0) {
          this.currentRemaining = Math.max(0, this.currentRemaining - (1 / 60));
        }
      }, 1000);
    }
  }

  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }

  get displayTime(): string {
    if (this.currentRemaining === null) return "--:--";
    if (this.currentRemaining <= 0) return "TERLAMBAT";
    const mins = Math.floor(this.currentRemaining);
    const secs = Math.floor((this.currentRemaining - mins) * 60);
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  }

  get timerColor(): string {
    if (this.currentRemaining === null) return "grey";
    if (this.currentRemaining <= 0) return "red";
    if (this.currentRemaining <= 5) return "red";
    if (this.currentRemaining <= 15) return "orange";
    return "green";
  }

  get timerClass(): string {
    return `${this.timerColor}--text`;
  }
}
